module.exports = new __parcel__URL__("eradicator.e111fb3f.png").toString();